import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store';
import Home from '@/pages/Home'
import jwt_decode from "jwt-decode";

import Errors from '../pages/General/Error/'
import Forbidden from '../pages/General/Error/Forbidden'

import Login from '../pages/General/Users/Login'

import Accounts from '../pages/Alarmsis/Account/'
import AccountList from '../pages/Alarmsis/Account/List'
import AccountAdd from '../pages/Alarmsis/Account/Add'
import AccountDetail from '../pages/Alarmsis/Account/Detail'
import AccountEdit from '../pages/Alarmsis/Account/Edit'

import Signal from '../pages/Alarmsis/Signal/'
import TrafficList from '../pages/Alarmsis/Signal/TrafficList'

import Customer from '../pages/General/Customer/'
import CustomerList from '../pages/General/Customer/List'
import CustomerAdd from '../pages/General/Customer/Add'
import CustomerEdit from '../pages/General/Customer/Edit'

import Dealer from '../pages/General/Dealer/'
import DealerAdd from '../pages/General/Dealer/Add'
import DealerEdit from '../pages/General/Dealer/Edit'
import DealerList from '../pages/General/Dealer/List'
import ServiceForms from '../pages/General/Dealer/ServiceForms'
import ServiceFormMovements from '../pages/General/Dealer/ServiceFormMovements'
import AddServiceForm from '../pages/General/Dealer/AddService'
import ServiceFormMovementAdd from '../pages/General/Dealer/ServiceFormMovementAdd'
import ServiceFormDetail from '../pages/General/Dealer/ServiceDetail'
import ServiceMaps from '../pages/General/Dealer/ServiceMaps'

import User from '../pages/General/Users/'
import UserList from '../pages/General/Users/List'
import UserAdd from '../pages/General/Users/Add'
import UserEdit from '../pages/General/Users/Edit'
import UserChangePass from '../pages/General/Users/ChangePass'
import UserChangeDefaultPass from '../pages/General/Users/ChangeDefault'
import AuthList from '../pages/General/Users/AuthList'
import AuthCasbin from '../pages/General/Users/AuthCasbin'
import AuthMenus from '../pages/General/Users/AuthMenus'
import AuthAdd from '../pages/General/Users/AddAuth'
import UserLogs from '../pages/General/Users/Logs'
import LDAPFilters from '../pages/General/Users/LDAPFilters'
import AddLDAPFilter from '../pages/General/Users/AddLDAPFilter'
import EditLDAPFilter from '../pages/General/Users/EditLDAPFilter'

import Defination from '../pages/General/Defination/'
import DefinationAddress from '../pages/General/Defination/Address'
import DefinationProtocols from '../pages/General/Defination/SignalProtocols'
import DefinationSignalGroups from '../pages/General/Defination/SignalGroups'
import DefinationSignalDescription from '../pages/General/Defination/SignalDescription'
import DefinationNoteType from '../pages/General/Defination/NoteType'
import DefinationZoneType from '../pages/General/Defination/ZoneType'
import DefinationEvaluationResult from '../pages/General/Defination/EvaluationResult'
import DefinationQuickNote from '../pages/General/Defination/QuickNote'
import DefinationJob from '../pages/General/Defination/Job'
import DefinationSubscriptions from '../pages/General/Defination/Subscriptions'
import DefinationAccountTypes from '../pages/General/Defination/AccountTypes'
import DefinationPanel from '../pages/General/Defination/Panel'
import DefinationTask from '../pages/General/Defination/Task'
import DefinationMenu from '../pages/General/Defination/Menu'
import DefinationCustomField from '../pages/General/Defination/CustomField'
import DefinationProducts from '../pages/General/Defination/Products'
import DefinationVacations from '../pages/General/Defination/Vacations'
import DefinationVacationsJobs from '../pages/General/Defination/VacationsJobs'
import DefinationImportantNumber from '../pages/General/Defination/ImportantNumber'
import DefinationStockMovementType from '../pages/General/Defination/StockMovementType'
import DefinationFaultSupportPieces from '../pages/General/Defination/FaultSupportPieces'
import DefinationFaultSupportResults from '../pages/General/Defination/FaultSupportResults'
import DefinationReceivers from '../pages/General/Defination/ReceiverSettings'
import DefinationReceiverFormat from '../pages/General/Defination/RecProtocol'
import DefinationADField from '../pages/General/Defination/ADField'
import DefinationConstants from '../pages/General/Defination/Constants'

import Reports from '../pages/General/Reports/'
import SafetyReport from '../pages/General/Reports/Safety'
import SignalReport from '../pages/General/Reports/Signal'
import CustomExcel from '../pages/General/Reports/CustomExcel'
import GeneralReport from '../pages/General/Reports/General'
import HistoryTracking from '../pages/General/Reports/TrackHistory'

import Ticket from '../pages/Support/Ticket'
import TicketList from '../pages/Support/Ticket/List'
import TicketAdd from '../pages/Support/Ticket/Add'
import TicketDetail from '../pages/Support/Ticket/Detail'
import TicketAssignments from '../pages/Support/Ticket/Assignments'

import Stock from '../pages/ERP/Stock'
import StockList from '../pages/ERP/Stock/List'
import StockEdit from '../pages/ERP/Stock/Edit'
import StockAdd from '../pages/ERP/Stock/Add'
import BarcodeCreator from '../pages/ERP/Stock/Barcode'
import StockMovementsAdd from '../pages/ERP/Stock/MovementsAdd'
import StockMovementsList from '../pages/ERP/Stock/MovementsList'
import FaultSupportsAdd from '../pages/ERP/Stock/FaultSupportsAdd'
import FaultSupportsList from '../pages/ERP/Stock/FaultSupportsList'
import FaultSupportsDetail from '../pages/ERP/Stock/FaultSupportsDetail'
import FaultSupportsTracking from '../pages/ERP/Stock/FaultSupportsTracking'

import Warehouse from '../pages/ERP/Warehouse'
import WarehouseList from '../pages/ERP/Warehouse/List'
import WarehouseAdd from '../pages/ERP/Warehouse/Add'
import WarehouseProducts from '../pages/ERP/Warehouse/Products'
import WarehouseEdit from '../pages/ERP/Warehouse/Edit'





Vue.use(Router)
const router = new Router({
  routes: [
    { path: '/login', name: 'Login', component: Login, meta:{ menu_id: 0} },
    { path: '/', name: 'Home', component: Home, meta:{ menu_id: 0}  },
    { path: '/Error', name: 'Error', component: Errors, meta:{ menu_id: 0}, children: [
      { path: 'Forbidden', name: 'Forbidden', component: Forbidden, meta:{ menu_id: 0}  },
    ] },
    { path: '/Accounts', name: 'Accounts', component: Accounts, meta:{ menu_id: 0}, children: [
      { path: 'List', component: AccountList, meta:{ menu_id: 31}  },
      { path: 'Add/:id', component: AccountAdd, meta:{ menu_id: 0} },
      { path: ':id', component: AccountDetail, meta:{ menu_id: 0}  },
      { path: ':cid/:id/edit', component: AccountEdit, meta:{ menu_id: 0}  },
    ] },
    { path: '/Signal', name: 'Signal', component: Signal, meta:{ menu_id: 0}, children: [
      {path: 'List', component: TrafficList, meta:{ menu_id: 33} }
    ]},
    { path: '/Customer', name: 'Customer', component: Customer, meta:{ menu_id: 0}, children: [
      {path: 'List', component: CustomerList,  meta:{ menu_id: 29}},
      {path: 'Add', component: CustomerAdd,  meta:{ menu_id: 27}},
      {path: ':id/Edit', component: CustomerEdit,  meta:{ menu_id: 0}}
    ]},
    { path: '/Dealer', name: 'Dealer', component: Dealer,meta:{ menu_id: 0},  children: [
      {path: 'Add', component: DealerAdd, meta:{ menu_id: 35}},
      {path: ':id/Edit', component: DealerEdit, meta:{ menu_id: 0}},
      {path: 'List', component: DealerList, meta:{ menu_id: 37}},
      {path: 'ServiceForms', component: ServiceForms, meta:{ menu_id: 0}},
      {path: 'ServiceMaps', component: ServiceMaps, meta:{ menu_id: 0}},
      {path: 'ServiceForms/Add', component: AddServiceForm, meta:{ menu_id: 0}},
      {path: 'ServiceForms/:id/Movements', component: ServiceFormMovements, meta:{ menu_id: 0}},
      {path: 'ServiceForms/:id/Movements/Add', component: ServiceFormMovementAdd, meta:{ menu_id: 0}}, 
      {path: 'ServiceForms/:id', component: ServiceFormDetail, meta:{ menu_id: 0}}      
    ]},
    { path: '/User', name: 'User', component: User,meta:{ menu_id: 0},  children: [
      {path: 'List', component: UserList, meta:{ menu_id: 69}},
      {path: 'Add', component: UserAdd, meta:{ menu_id: 71}},
      {path: ':id/Edit', component: UserEdit, meta:{ menu_id: 0}},
      {path: 'Change', component: UserChangePass, meta:{ menu_id: 73}},
      {path: 'ChangeDefault', name:'ChangeDefault', component: UserChangeDefaultPass, meta:{ menu_id: 73}},
      {path: 'Auth', component: AuthList, meta:{ menu_id: 0}},
      {path: 'Auth/:id/Casbin', component: AuthCasbin, meta:{ menu_id: 0}},
      {path: 'Auth/:id/Menus', component: AuthMenus, meta:{ menu_id: 0}},
      {path: 'AddAuth', component: AuthAdd, meta:{ menu_id: 0}},
      {path: 'Logs', component: UserLogs, meta:{ menu_id: 0}},
      {path: 'LDAP/Filters', component: LDAPFilters, meta:{ menu_id: 0}},
      {path: 'LDAP/Filters/Add', component: AddLDAPFilter, meta:{ menu_id: 0}},
      {path: 'LDAP/Filter/:id/edit', component: EditLDAPFilter, meta:{ menu_id: 0}}  
    ]},
    { path: '/Defination', name: 'Defination', component: Defination, meta:{ menu_id: 0}, children: [
      {path: 'Address', component: DefinationAddress, meta:{ menu_id: 43}},
      {path: 'Protocols', component: DefinationProtocols, meta:{ menu_id: 47}},
      {path: 'SignalGroups', component: DefinationSignalGroups, meta:{ menu_id: 49}},
      {path: 'SignalDescription', component: DefinationSignalDescription, meta:{ menu_id: 51}},
      {path: 'NoteType', component: DefinationNoteType, meta:{ menu_id: 53}},
      {path: 'ZoneType', component: DefinationZoneType, meta:{ menu_id: 55}},
      {path: 'EvaluationResult', component: DefinationEvaluationResult, meta:{ menu_id: 57}},
      {path: 'QuickNote', component: DefinationQuickNote, meta:{ menu_id: 59}},
      {path: 'Job', component: DefinationJob, meta:{ menu_id: 61}},
      {path: 'Subscriptions', component: DefinationSubscriptions, meta:{ menu_id: 63}},
      {path: 'AccountTypes', component: DefinationAccountTypes, meta:{ menu_id: 65}},
      {path: 'Panel', component: DefinationPanel, meta:{ menu_id: 45}},
      {path: 'Task', component: DefinationTask, meta:{ menu_id: 67}},
      {path: 'Menus', component: DefinationMenu, meta:{ menu_id: 75}},
      {path: 'Products', component: DefinationProducts, meta:{ menu_id: 0}},
      {path: 'Vacations', component: DefinationVacations, meta:{ menu_id: 0}},
      {path: 'Vacations/:id/Jobs', component: DefinationVacationsJobs, meta:{ menu_id: 0}},
      {path: 'CustomField', component: DefinationCustomField, meta:{ menu_id: 0}},
      {path: 'ImportantNumber', component: DefinationImportantNumber, meta:{ menu_id: 0}},
      {path: 'StockMovementType', component: DefinationStockMovementType, meta:{ menu_id: 0}},
      {path: 'FaultSupportPieces', component: DefinationFaultSupportPieces, meta:{ menu_id: 0}},
      {path: 'FaultSupportResults', component: DefinationFaultSupportResults, meta:{ menu_id: 0}},
      {path: 'Receivers', component: DefinationReceivers, meta:{ menu_id: 0}},
      {path: 'ReceiverFormats', component: DefinationReceiverFormat, meta:{ menu_id: 0}},
      {path: 'ADManager', component: DefinationADField, meta:{ menu_id: 0}},
      {path: 'Constants', component: DefinationConstants, meta:{ menu_id: 0}},
      
    ]},
    {path: '/Reports', name: 'Reports', component: Reports,meta:{ menu_id: 0}, children: [
      {path: 'SafetyReport', component: SafetyReport, meta:{ menu_id: 0}},
      {path: 'Signal', component: SignalReport, meta:{ menu_id: 0}},
      {path: 'CustomReport/:code', component: CustomExcel, meta:{ menu_id: 0}},
      {path: 'General', component: GeneralReport, meta:{ menu_id: 0}},
      {path: 'HistoryTracking', component: HistoryTracking, meta:{ menu_id: 0}},
      
    ]},
    {path: '/Ticket', name: 'Ticket', component: Ticket, meta:{ menu_id: 0}, children: [
      {path: 'List', component: TicketList, meta:{ menu_id: 0}},
      {path: 'Add', component: TicketAdd, meta:{ menu_id: 0}},
      {path: ':id/Detail', component: TicketDetail, meta:{ menu_id: 0}},
      {path: 'Assignments', component: TicketAssignments, meta:{ menu_id: 0}}
    ]},
    {path: '/Stock', name: 'Stock', component: Stock, meta:{ menu_id: 0}, children: [
      {path: 'List', component: StockList, meta:{ menu_id: 0}},
      {path: 'Add', component: StockAdd, meta:{ menu_id: 0}},
      {path: ':id/Edit', component: StockEdit, meta:{ menu_id: 0}},
      {path: 'Movements', component: StockMovementsList, meta:{ menu_id: 0}},
      {path: 'Movements/Add', component: StockMovementsAdd, meta:{ menu_id: 0}},
      {path: 'FaultSupports', component: FaultSupportsList, meta:{ menu_id: 0}},
      {path: 'FaultSupports/Add', component: FaultSupportsAdd, meta:{ menu_id: 0}},
      {path: 'FaultSupports/:id', component: FaultSupportsDetail, meta:{ menu_id: 0}},
      {path: 'FaultSupportTracking', component: FaultSupportsTracking, meta:{menu_id: 0}},
      {path: 'Barcode', component: BarcodeCreator, meta:{menu_id: 0}},
    ]},
    {path: '/Warehouse', name: 'Warehouse', component: Warehouse, meta:{ menu_id: 0}, children: [
      {path: 'List', component: WarehouseList, meta:{ menu_id: 0}},
      {path: 'Add', component: WarehouseAdd, meta:{ menu_id: 0}},
      {path: ':id/Products', component: WarehouseProducts, meta:{ menu_id: 0}},
      {path: ':id/Edit', component: WarehouseEdit, meta:{ menu_id: 0}}

    ]},
    { 
      path: '/:catchAll(.*)', 
      component: Login,
      name: 'NotFound'
    }
    
  ],
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('access_token')  || to.name === 'Login') {
    if(to.name === 'Forbidden' || to.name == 'ChangeDefault'){
      next()
    }else{
      to.matched.some(async record => {
        if(store.getters.getUserMenus.length == 0 && localStorage.getItem('access_token')){
          store.dispatch('listAuthMenu',jwt_decode(localStorage.getItem('access_token')).auth_code)
        }
        let menus = store.getters.getAuthMenus
        let auth = false
    
        menus.map((m)=>{
          if(m.children && m.children.length>0){
            m.children.map((mc)=>{
              if(record.meta.menu_id == mc.id)
                auth = true
            })
          }else{
            if(record.meta.menu_id == m.id)
                auth = true
          }
        })
        
        if(record.meta.menu_id == 0 || auth){
          return next()
        }else{
          next({
            path: '/Error/Forbidden'
          });
        }
        next()
        
      })
    }
    
  } else {
    // Not logged in, redirect to login.
    next({name: 'Login'})
  }

})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js